module.exports = __webpack_public_path__ + "img/vinyl-disk.e238d40e.png";